export default __webpack_public_path__ + "static/media/advisory-hero.0d42e7be.jpg";